import { Info as InfoCore } from '@tink/core/src/components/atoms/Info/Info';
import { styled } from '../../../core/theme/styled';

export const Info = styled(InfoCore)`
  && {
    background-color: ${(props) => props.theme.configuration.backgroundColor};
    border-radius: ${(props) => props.theme.roundedCorners.medium};
    color: ${(props) => props.theme.configuration.primaryTextColor};
  }
`;
